import {
  FETCH_USER_AUTHENTICATION_WATCHER,
  SET_USER_AUTHENTICATION,
  SET_USER_AUTHENTICATION_ERROR
} from "../actionTypes/index";

export const fetchUserAuthanticationWatcher = (payload, resolve, reject) => {
  return { type: FETCH_USER_AUTHENTICATION_WATCHER, payload, resolve, reject };
};

export const setUserAuthantication = (payload, resolve, reject) => {
  return { type: SET_USER_AUTHENTICATION, payload, resolve, reject };
};

export const setUserAuthanticationError = (payload, resolve, reject) => {
  return { type: SET_USER_AUTHENTICATION_ERROR, payload, resolve, reject };
};
